;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface ChatIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function ChatIcon({ size = 24, ...props }: ChatIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.875 0.75C1.57663 0.75 1.29048 0.868527 1.0795 1.0795C0.868527 1.29048 0.75 1.57663 0.75 1.875V5.875C0.75 6.17337 0.868527 6.45952 1.0795 6.6705C1.29048 6.88147 1.57663 7 1.875 7H3.375C3.47446 7 3.56984 7.03951 3.64017 7.10984L4.875 8.34467L6.10984 7.10984C6.18016 7.03951 6.27554 7 6.375 7H7.875C8.17337 7 8.45952 6.88147 8.6705 6.6705C8.88147 6.45952 9 6.17337 9 5.875V1.875C9 1.57663 8.88147 1.29048 8.6705 1.0795C8.45952 0.868527 8.17337 0.75 7.875 0.75H1.875ZM0.549175 0.549175C0.900806 0.197544 1.37772 0 1.875 0H7.875C8.37228 0 8.84919 0.197544 9.20083 0.549175C9.55246 0.900806 9.75 1.37772 9.75 1.875V5.875C9.75 6.37228 9.55246 6.84919 9.20083 7.20083C8.84919 7.55246 8.37228 7.75 7.875 7.75H6.53033L5.14016 9.14017C4.99372 9.28661 4.75628 9.28661 4.60984 9.14017L3.21967 7.75H1.875C1.37772 7.75 0.900806 7.55246 0.549175 7.20083C0.197544 6.84919 0 6.37228 0 5.875V1.875C0 1.37772 0.197544 0.900806 0.549175 0.549175ZM2.5 2.875C2.5 2.66789 2.66789 2.5 2.875 2.5H6.875C7.08211 2.5 7.25 2.66789 7.25 2.875C7.25 3.08211 7.08211 3.25 6.875 3.25H2.875C2.66789 3.25 2.5 3.08211 2.5 2.875ZM2.5 4.875C2.5 4.66789 2.66789 4.5 2.875 4.5H5.875C6.08211 4.5 6.25 4.66789 6.25 4.875C6.25 5.08211 6.08211 5.25 5.875 5.25H2.875C2.66789 5.25 2.5 5.08211 2.5 4.875Z"
        fill="currentColor"
      />
    </svg>
  );
}
